import { ScrollbarPlugin } from 'smooth-scrollbar'
import { Data2d } from 'smooth-scrollbar/interfaces'

export class NhShapeAnimationPlugin extends ScrollbarPlugin {
  static pluginName = 'nhShapeAnimation'

  static defaultOptions = {
    isOnContainer: false,
    handleContainerScroll: null,
  }

  transformDelta(delta: Data2d, event: Event | KeyboardEvent): Data2d {
    if (
      (/(wheel|touchmove)/.test(event.type) &&
        this.options.handleContainerScroll) ||
      (event instanceof KeyboardEvent &&
        /(PageUp|PageDown|End|Home|ArrowUp|ArrowDown)/.test(event.key) &&
        this.options.handleContainerScroll)
    ) {
      this.options.handleContainerScroll(delta, event)
    }

    return delta
  }
}
